<template>
  <div class="schoolCardList-container div-layout">
    <module-title title="校牌权限管理列表" />
    <div class="schoolCardList-right-contain">
      <el-form
        ref="schoolCardSearchForm"
        class="schoolCardSearchForm"
        :model="searchForm"
        :inline="true"
        label-position="right"
      >
        <el-form-item label="IMEI号：" prop="imei">
          <el-input
            v-model="searchForm.imei"
            name="imei"
            auto-complete="off"
            size="medium"
            placeholder="请输入"
            clearable
          />
        </el-form-item>

        <el-form-item style="margin-left:20px;">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="fetchSearchFile"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="listLoading"
        :data="schoolCardPermissionList"
        fit
        element-loading-text="Loading"
        class="list-table"
        highlight-current-row
      >
        <el-table-column label="序号" type="index" align="center" width="55" />
        <el-table-column label="一卡通卡号" prop="deviceNo" align="center" width="150" />
        <el-table-column label="IMEI号" prop="imei" align="center" width="150" />
        <el-table-column label="绑定状态" prop="bindStatusDesc" align="center" />
        <el-table-column label="所在学校" prop="schoolName" align="center" />
        <el-table-column label="年级" prop="gradeName" align="center" />
        <el-table-column label="班级" prop="className" align="center" />
        <el-table-column label="学号" prop="studentNum" align="center" />
        <el-table-column label="绑定学生" prop="name" align="center" />
        <el-table-column label="操作" align="center" width="360">
          <template slot-scope="scope">
            <el-button
              type="warning"
              size="small"
              icon="el-icon-warning-outline"
              @click="switchUSB(scope.row,1)"
            >
              打开USB权限
            </el-button>
            <el-button
              type="success"
              size="small"
              icon="el-icon-warning-outline"
              @click="switchUSB(scope.row,0)"
            >
              关闭USB权限
            </el-button>
            <el-dropdown
              trigger="click"
              class="moreBtn"
              @visible-change="scope.row.more = !scope.row.more"
              @command="handleCommand($event,scope.row)"
            >
              <el-button type="primary" size="small" class="marginleft-10">
                更多
                <i
                  :class="[scope.row.more?'el-icon-arrow-up':'el-icon-arrow-down','el-icon--right']"
                />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="blue" command="a" icon="el-icon-edit">
                  设置单片机卡号
                </el-dropdown-item>
                <!-- <el-dropdown-item class="blue" command="b" icon="el-icon-edit">操作记录</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="searchForm.total"
        :page.sync="searchForm.pageNum"
        :limit.sync="searchForm.pageSize"
        @pagination="pageCurriculumList"
        @handleSizeChange="handleSizeChange"
      />
    </div>

    <!-- 异常数据 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      title="操作记录"
    >
      <el-scrollbar wrap-class="abnormal-table">
        <el-table
          :data="abnormalDataList"
          fit
          highlight-current-row
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="操作账号" prop="errorMsg" align="center" />
          <el-table-column label="操作时间" prop="errorMsg" align="center" />
          <el-table-column label="操作" prop="errorMsg" align="center" />
        </el-table>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSchooleCardAuthList,
  getSchooleCardAuthSwitchUSB,
  getSchooleCardAuthPushDeviceNo
} from '@/api/systemMaintenance/devicManage/illegalCheck';
export default {
  name: 'SchoolCardPermission',
  data() {
    return {
      schoolCardPermissionList: [],
      searchForm: {
        imei: '',
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      listLoading: false,
      dialogVisible: false,
      flagClick: true, // 更新卡号隔5秒点击调用
      abnormalDataList: []
    };
  },
  mounted() {
    this.fetchPermissionList();
    console.log(this.$route);
  },
  methods: {
    handleCommand(command, row) {
      if (command === 'a') {
        var _self = this;
        if (_self.flagClick) {
          _self.flagClick = false;
          _self.schooleCardAuthPushDeviceNo(row);// 更新卡号
          setTimeout(function() { _self.flagClick = true; }, 1000 * 5);// 隔5秒点击调用
        }
      } else {
        this.dialogVisible = true;
      }
    },
    schooleCardAuthPushDeviceNo(row) {
      var options = {
        imei: row.imei,
        deviceNo: row.deviceNo
      };
      getSchooleCardAuthPushDeviceNo(options)
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '操作成功',
            showClose: false,
            duration: 2000
          });
          this.fetchPermissionList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchPermissionList();
    },

    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageSize = obj.limit;
      this.fetchSearchFile();
    },
    fetchSearchFile() {
      this.searchForm.pageNum = 1;
      this.fetchPermissionList();
    },
    // 获取列表名单
    fetchPermissionList() {
      var option = {
        ...this.searchForm
      };
      delete option.total;
      getSchooleCardAuthList(option).then(res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.schoolCardPermissionList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.schoolCardPermissionList = [];
        }
      });
    },
    // 开关USB
    switchUSB(row, val) {
      var options = {
        imei: row.imei,
        flag: val
      };
      getSchooleCardAuthSwitchUSB(options)
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '操作成功',
            showClose: false,
            duration: 2000
          });
          this.fetchPermissionList();
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.schoolCardList-container {
  .schoolCardSearchForm{
    padding: 0 20px;
  }
    .edit-form-input {
      width: 6.8vw;
    }
    .textCenter{text-align: center;padding: 20px;
    .el-button {
      width: 160px;
    }

  }

  // .handle-form-input{ width: 160px;}
  // 查看详情
  .archivesTitle {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 30px;
    padding-bottom: 20px;
  }
  .marginleft-10{
    margin-left: 10px;
  }
  .red{color: red;}
  .manager-info {
    ul {
      margin-left: 60px;
      width: 50%;
      min-width: 220px;
      li {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
